import React from 'react';
import Box from '../Box/Box';
import { SxProp } from '../style/sxProp';
import useTheme from '../style/useTheme';

export type Props = {
  sx?: SxProp;
};

const LayoutGrid: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  sx,
}) => {
  const { resolveSpacing } = useTheme();
  const pseudoElementsForThreeColumns =
    3 - (React.Children.count(children) % 3);
  const pseudoElementsForFourColumns = 4 - (React.Children.count(children) % 4);

  const createPseudoElementStyle = (
    columns: number,
    lastRowCount: number
  ): SxProp =>
    lastRowCount === 0
      ? {}
      : {
          '::after': {
            content: '""',
            flex: `1 1 calc(${((100 / columns) * lastRowCount).toFixed(
              3
            )}% - ${resolveSpacing(1)})`,
            // visibility: 'hidden',
            marginBottom: resolveSpacing(3),
            marginLeft: resolveSpacing(0.5),
            marginRight: resolveSpacing(0.5),
          },
        };

  const olStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    padding: resolveSpacing(2),
    listStyle: 'none',
    boxSizing: 'border-box',
    margin: 0,
    ...createPseudoElementStyle(3, pseudoElementsForThreeColumns),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...(sx as any),
    '@media screen and (min-width: 768px)': {
      ...createPseudoElementStyle(4, pseudoElementsForFourColumns),
      flex: `1 1 calc(25% - ${resolveSpacing(1)})`, // Adjust for 4 columns on medium screens
    },
    '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
      // IE11-specific
    },
  };

  const liStyle = {
    flex: `1 1 calc(33.333% - ${resolveSpacing(1)})`, // Adjust the subtraction for margin
    marginBottom: resolveSpacing(3), // Spacing between rows
    marginLeft: resolveSpacing(0.5),
    marginRight: resolveSpacing(0.5),
    display: 'flex',
    justifyContent: 'center',
    '@media screen and (min-width: 768px)': {
      flex: `1 1 calc(25% - ${resolveSpacing(1)})`, // Adjust for 4 columns on medium screens
    },
  };

  return (
    <Box as="ol" sx={olStyle}>
      {React.Children.map(children, (child) => (
        <Box as="li" sx={liStyle}>
          {child}
        </Box>
      ))}
    </Box>
  );
};

export default LayoutGrid;
